import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import HeadWithSubHead from "../../common/HeadWithSubHead";
import styles from "./OfflineOnboarding.module.css";
import OfflineRemitter from "../../component/offlinePayment/remitter/remitter";
import OfflineStudent from "../../component/offlinePayment/student/student";
import OfflineDownloadDocuments from "../../component/offlinePayment/downloadDocs/OfflineDownloadDocuments";
import NewHeader from "../NavBar/newHeader";
import { useMyContext } from "../../myContext";
import { useNavigate } from "react-router";
import rightArrow from "../../public/assets/rightArrow.svg";

function OfflineOnboarding() {
  const [stepToShowOffline, setStepToShowOffline] = useState(1);
  const {themeColor, offlineRemitterUserId, offlineStudentUserId, remitterOfflineDetail, studentOfflineDetail, userStatus} = useMyContext();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if(sessionStorage.getItem("offlineUserStatus") !== "offlineOnboarding"){
      navigate('/transaction-detail', { replace: true });
      window.location.reload();
    }
  },[])

  const onBoardingComplete = () => {
    sessionStorage.setItem("offlineremitterId",offlineRemitterUserId);
    sessionStorage.setItem("offlineStudentId",offlineStudentUserId);
    const offlineAccountDetail = {
      remitter: remitterOfflineDetail,
      student: studentOfflineDetail,
    };
    sessionStorage.setItem("offlineAccountDetail", JSON.stringify(offlineAccountDetail));
    sessionStorage.setItem("nextStep","quote");
    sessionStorage.setItem("offlineUserStatus", "offlineTransaction")
    navigate('/offline-transaction');
  };

  return (
    <>
    <NewHeader
        show={true}
      />
    <div className={`container ${styles.mainContainer}`}>
      <Row>
        <HeadWithSubHead
          head="Account Setup"
          subHead="Just a few steps away. This should take less than 10 mins."
        />
      </Row>
      <Row style={{ marginTop: "40px" }}>
        <>
        <OfflineRemitter stepToShowOffline={stepToShowOffline} setStepToShowOffline={setStepToShowOffline}/>
        <OfflineStudent stepToShowOffline={stepToShowOffline} setStepToShowOffline={setStepToShowOffline}/>
        <OfflineDownloadDocuments stepToShowOffline={stepToShowOffline} setStepToShowOffline={setStepToShowOffline}/>
        </>
      </Row>
      <Row style={{ paddingTop: "20px" }}>
          <Col style={{padding: "0px"}}>
            <Button
              className={`${styles.generateButton} ${
                stepToShowOffline === 6 ? "" : styles.disabledButton
              }`}
              disabled={stepToShowOffline !== 6}
              style={{
                cursor: stepToShowOffline !== 6 ? "not-allowed" : "pointer",
                background: themeColor
              }}
              onClick={onBoardingComplete}
            >
              Proceed
              <img className={styles.rightArrow} style={{marginLeft: "6px"}} src={rightArrow} alt="" />
            </Button>
          </Col>
        </Row>
    </div>
    </>
  );
}

export default OfflineOnboarding;
